export function loadNoticeList(client, from) {
  return {
    type: 'LOAD_NOTICE_LIST',
    client,
    from,
  };
}

export function loadNoticeListCompletion(
  error = null,
  list = [],
  didLoadAt = 0
) {
  return {
    type: 'LOAD_NOTICE_LIST_COMPLETION',
    error,
    list,
    didLoadAt,
  };
}

export function shiftNotice() {
  return {
    type: 'SHIFT_NOTICE',
  };
}
